"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerActionSystem = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
class PlayerActionSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.PLAYER_ACTION);
        this.grabCooldown = 0;
    }
    onInit() { }
    onClear() {
    }
    makeToolUi() {
    }
    repositionToolUI() {
    }
    onStart() {
    }
    onStop() { }
    onPeerMessage(peerId, message) {
    }
    onServerMessage(message) {
    }
    onEntityAddedComponent(entity, component) {
        this.clientPlayerComponent = component;
    }
    update(delta) {
        if (this.globals.clientPlayer && this.clientPlayerComponent.actionAttachment && this.globals.clientPlayer.playerInput.grab && !this.$api.isInDialogue() && !this.$api.isInventoryOpen() && !this.grabCooldown) {
        }
        if (this.grabCooldown > .5) {
            this.grabCooldown -= delta;
        }
    }
    handlePlayerEquipItem(itemName) {
        if (itemName === 'net' || itemName === 'shovel' || itemName === 'axe') {
            this.clientPlayerComponent.actionAttachment = itemName;
        }
        else {
            this.clientPlayerComponent.actionAttachment = null;
        }
    }
    onLocalMessage(message) {
        switch (message.type) {
            case Constants_1.MESSAGES.EQUIP_ITEM:
                this.handlePlayerEquipItem(message.data);
                break;
        }
    }
}
exports.PlayerActionSystem = PlayerActionSystem;
function makeRectTexture(w, h, color, outlineColor, outlineWidth, renderer) {
    outlineColor = outlineColor ? outlineColor : color;
    outlineWidth = outlineWidth ? outlineWidth : 0;
    const g = new PIXI.Graphics();
    g.beginFill(color);
    if (outlineWidth) {
        g.lineStyle(outlineWidth, outlineColor);
    }
    g.drawRect(outlineWidth, outlineWidth, w - outlineWidth, h - outlineWidth);
    const texture = PIXI.RenderTexture.create(w, h);
    renderer.render(g, texture);
    return texture;
}
//# sourceMappingURL=module.js.map